import type { AdminScopeCounts } from '@steado/admin-contract/scope-counts';

import type { GymsFilters } from './gyms-query';

/**
 * The Gyms list's pills: every gym, and the gyms whose owner has not finished
 * setup. Counts come from `/admin/scope-counts`, like every other list's pills.
 */
export const GYM_SCOPES = [
  { id: 'all', label: 'Everyone', countKey: 'all', filters: {} },
  { id: 'setup', label: 'Setup unfinished', countKey: 'setupNotDone', filters: { setup: 'not_done' } },
] as const satisfies readonly {
  readonly id: string;
  readonly label: string;
  readonly countKey: keyof AdminScopeCounts['gyms'];
  readonly filters: Partial<GymsFilters>;
}[];

export type GymScopeId = (typeof GYM_SCOPES)[number]['id'];

/** The pill the filters amount to, derived so a hand-edited URL and a click cannot disagree. */
export function scopeForFilters(filters: GymsFilters): GymScopeId {
  return filters.setup === 'not_done' ? 'setup' : 'all';
}

/** The filters a pill sets; the search box survives the change. */
export function filtersForScope(id: GymScopeId, current: GymsFilters): GymsFilters {
  const scope = GYM_SCOPES.find((candidate) => candidate.id === id);
  return {
    ...(current.search === undefined ? {} : { search: current.search }),
    ...(scope?.filters ?? {}),
  };
}
